import { RelationalTableDataset } from './../../dataset/relational-table.dataset';
import { IAttribute } from '../../base/annotation';
import { TabularCopySource } from './tabular-type.copysource';

import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { SapHanaDataset } from 'app/model/dataset/saphana.dataset';
import { partitionOptionConst } from 'app/registries/consts/metadata-consts';

@Metamodel.model({
    name: adfModelTypeMap.sapHana.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(SapHanaDataset),
            Metamodel.modelFor(RelationalTableDataset)
        ]
    }
})
export class SapHanaCopySource extends TabularCopySource {
    public static readonly PACKET_SIZE: IAttribute;
    public static readonly PARTITION_OPTION: IAttribute;
    public static readonly PARTITION_COLUMN_NAME: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'PACKET_SIZE',
        display: stringResources.ModelName_SapHanaSourcePacketSize,
        constraint: {
            minimum: 1024,
            maximum: 2097151
        }
    })
    public packetSize?: number;

    @Metamodel.attribute({
        templatable: true,

        association: 'PARTITION_OPTION',
        display: stringResources.ModelName_Partition_Option
    })
    public partitionOption?: string = partitionOptionConst.none;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_COLUMN_NAME',
        display: stringResources.ModelName_Partition_ColumnName
    })
    public partitionColumnName?: string;
}
